export default "__VITE_ASSET__ddba8cc0__"